/* slothy-custom.js – PITAKA swatch enhancements + product badges
   1. Snap-style product cards: patch updateProductImage to support slider structure
   2. Collection cards: update card title on swatch click
   3. Product page: update H1 title when variant changes
   4. Apply swatch images directly via inline styles (bypasses CSS minifier issues)
   5. Inject product badges (יבואן רשמי / edition) on card image and product page image
*/
(function () {
  'use strict';

  /* ── Swatch image map ── */
  var SWATCH_IMAGES = {
    'Sunset (Aaron Button)': 'https://cdn.shopify.com/s/files/1/0555/2953/7831/files/Black-S26-sunset-edge.webp?v=1775932753',
    'Moonrise (Aaron Button)': 'https://cdn.shopify.com/s/files/1/0555/2953/7831/files/Pinkgold-S26-moonrise-edge.webp?v=1775932753',
    '600D Black/Grey (Twill) (Aaron Button)': 'https://cdn.shopify.com/s/files/1/0555/2953/7831/files/CobaltViolet-S26-black-edge.webp?v=1775932439',
    'Amber (PitaTap\u2122)': 'https://cdn.shopify.com/s/files/1/0555/2953/7831/files/iPhone17-Pro-horse-orange-3.webp?v=1777822976',
    'Indigo (PitaTap\u2122)': 'https://cdn.shopify.com/s/files/1/0555/2953/7831/files/iPhone17-Pro-horse-blue-3.webp?v=1777822976',
    'Lucid Blue (PitaTap\u2122)': 'https://cdn.shopify.com/s/files/1/0555/2953/7831/files/iPhone17-glintblue-slim-6.webp',
    'Golden Glint (PitaTap\u2122)': 'https://cdn.shopify.com/s/files/1/0555/2953/7831/files/iPhone17-gold-slim-6.webp'
  };

  function applySwatchBg(el, imageUrl) {
    el.style.backgroundImage = 'url("' + imageUrl + '")';
    el.style.backgroundSize = 'cover';
    el.style.backgroundPosition = 'center';
    el.style.backgroundRepeat = 'no-repeat';
    el.style.backgroundColor = 'transparent';
  }

  /* Apply swatch images to all matching elements in the DOM */
  function applySwatchImages(root) {
    root = root || document;
    Object.keys(SWATCH_IMAGES).forEach(function (value) {
      var imageUrl = SWATCH_IMAGES[value];
      root.querySelectorAll('[data-value]').forEach(function (el) {
        if (el.getAttribute('data-value') === value) {
          applySwatchBg(el, imageUrl);
          /* product page: inner label is the visible circle */
          var label = el.querySelector('.m-product-option--node__label');
          if (label) applySwatchBg(label, imageUrl);
        }
      });
    });
  }

  function cleanColorLabel(raw) {
    var m = String(raw).match(/^([^(]+)/);
    return m ? m[1].trim() : raw;
  }

  /* ── Product badge definitions ── */
  var PRODUCT_BADGES = {
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-black-grey': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-sunset': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-moonrise': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-air-black-grey-copy': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-air-moonrise': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-air-sunset': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-pro-sunset-copy': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-pro-moonrise': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-pro-black-grey': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-pro-black-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-pro-max-sunset': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-pro-max-moonrise': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-pro-max-black-grey': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-17-pro-max-black-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'iphone-17-pro-ההגנה-האולטימטיבית-בסטייל-aramid-proguard-black-grey': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'iphone-17-pro-ההגנה-האולטימטיבית-בסטייל-aramid-proguard-sunset': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'iphone-17-pro-ההגנה-האולטימטיבית-בסטייל-aramid-proguard-moonrise': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'iphone-17-pro-max-ההגנה-האולטימטיבית-בסטייל-aramid-ultraguard': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'iphone-17-pro-max-ההגנה-האולטימטיבית-בסטייל-aramid-ultraguard-black-grey': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'iphone-17-pro-max-ההגנה-האולטימטיבית-בסטייל-aramid-proguard-moonrise': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'iphone-17-pro-max-ההגנה-האולטימטיבית-בסטייל-aramid-proguard-sunset': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'iphone-17-pro-max-ההגנה-האולטימטיבית-בסטייל-aramid-proguard-black-grey': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'glints-of-gold-phone-cases-iphone-air': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'glints-of-gold-iphone-17-lucid-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'glints-of-gold-iphone-17-golden-glint': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'glints-of-gold-iphone-17-pro-lucid-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'glints-of-gold-iphone-17-pro-golden-glint': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'glints-of-gold-iphone-17-pro-max-lucid-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'glints-of-gold-iphone-17-pro-max-golden-glint': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'happiness-rides-iphone-17-pro-amber': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'happiness-rides-iphone-17-pro-indigo': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'happiness-rides-iphone-17-pro-max-amber': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'happiness-rides-iphone-17-pro-max-indigo': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-california-dream': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-midnight': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-summer-noon': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-autumn-dusk': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-nearfield-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-lucid-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-burgundy': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-blues-red': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-abyss-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-sapphire-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-charoite-purple': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-black-grey': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-max-black-grey': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-max-california-dream': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-max-midnight': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-max-summer-noon': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-max-autumn-dusk': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-max-nearfield-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-max-lucid-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-max-burgundy': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-max-blues-red': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-max-abyss-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-max-sapphire-blue': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-הדק-והקל-בעולם-pitaka-פיטאקה-iphone-18-pro-max-charoite-purple': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-summa-pitaka-פיטאקה-iphone-18-pro-black-grey': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }],
    'מגן-הקרבון-summa-pitaka-פיטאקה-iphone-18-pro-max-black-grey': [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }, { type: 'edition', text: '\u2605 2026 Edition' }]
  };

  function makeBadgeWrap(badges) {
    var wrap = document.createElement('div');
    wrap.className = 'slothy-badge-wrap';
    badges.forEach(function (b) {
      var span = document.createElement('span');
      span.className = 'slothy-badge slothy-badge--' + b.type;
      span.textContent = b.text;
      wrap.appendChild(span);
    });
    return wrap;
  }

  /* Badge sets */
  var OFFICIAL_ONLY = [{ type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' }];
  var HOT_BADGE = [{ type: 'hot', text: '🔥 מוצר חם' }];
  var OFFICIAL_AND_EDITION = [
    { type: 'official', text: '\u2713 \u05d9\u05d1\u05d5\u05d0\u05df \u05e8\u05e9\u05de\u05d9' },
    { type: 'edition', text: '\u2605 2026 Edition' }
  ];

  function getBadgesForHandle(handle) {
    /* If explicitly mapped (iPhone 17 products) → use mapped badges */
    if (PRODUCT_BADGES[handle]) return PRODUCT_BADGES[handle];
    /* Anker / Soundcore products -> hot badge */
    if (handle && (handle.toLowerCase().indexOf('soundcore') !== -1 || handle.toLowerCase().indexOf('anker') !== -1)) return HOT_BADGE;
    /* All other PITAKA handles (contain "pitaka") → official importer only */
    if (handle && (handle.toLowerCase().indexOf('pitaka') !== -1 || handle.indexOf('glints-of-gold') !== -1 || handle.indexOf('happiness-rides') !== -1)) return OFFICIAL_ONLY;
    return null;
  }

  /* Inject badges onto collection cards and product page image */
  function injectProductBadges() {
    /* ── Collection cards ── */
    document.querySelectorAll('.m-product-card').forEach(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var handle = decodeURIComponent(href.replace(/.*\/products\//, '').split('?')[0]);
      var badges = getBadgesForHandle(handle);
      if (!badges || !badges.length) return;

      var mediaDiv = card.querySelector('.m-product-card__media');
      if (!mediaDiv || mediaDiv.querySelector('.slothy-badge-wrap')) return;

      mediaDiv.appendChild(makeBadgeWrap(badges));
    });

    /* ── Product page: use window.meta.product.vendor for reliable PITAKA detection ── */
    if (document.querySelector('.m-main-product--media .slothy-badge-wrap')) return;

    var mediaWrap = document.querySelector('.m-product-media--desktop.m-product-media--wrapper')
                 || document.querySelector('.m-main-product--media');
    if (!mediaWrap) return;

    var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
    var pageHandle = pathMatch ? decodeURIComponent(pathMatch[1]) : '';

    /* Check explicit map first (iPhone 17 with 2026 Edition) */
    var pageBadges = PRODUCT_BADGES[pageHandle];

    /* Fallback: detect vendor from Shopify meta object */
    if (!pageBadges) {
      var vendor = (window.meta && window.meta.product && window.meta.product.vendor) || '';
      var isPitaka = vendor === 'PITAKA' || pageHandle.toLowerCase().indexOf('pitaka') !== -1;
      var isAnker = vendor === 'Anker' || pageHandle.toLowerCase().indexOf('soundcore') !== -1 || pageHandle.toLowerCase().indexOf('anker') !== -1;
      if (isPitaka) pageBadges = OFFICIAL_ONLY;
      else if (isAnker) pageBadges = HOT_BADGE;
    }

    if (!pageBadges || !pageBadges.length) return;
    mediaWrap.appendChild(makeBadgeWrap(pageBadges));
  }

  /* ── 1 & 2: Collection cards ── */
  customElements.whenDefined('pcard-swatch').then(function () {
    var SwatchClass = customElements.get('pcard-swatch');
    var proto = SwatchClass.prototype;

    var origUpdateImage = proto.updateProductImage;
    proto.updateProductImage = function (variant) {
      if (this.featuredImage) {
        return origUpdateImage.call(this, variant);
      }
      var snap = this.pcard && this.pcard.querySelector('.m-product-card__snap-track');
      if (snap && variant && variant.featured_image) {
        var img = snap.querySelector('.m-product-card__snap-slide img');
        if (img) {
          img.src = variant.featured_image.src + '&width=533';
          img.removeAttribute('srcset');
        }
      }
    };

    var origHandleVariant = proto.handleVariantSelection;
    proto.handleVariantSelection = function (e) {
      origHandleVariant.call(this, e);
      var label = e.target.closest ? e.target.closest('.m-product-option--node__label')
                                   : null;
      if (!label) return;
      var value = label.dataset.value || (label.closest('[data-value]') && label.closest('[data-value]').dataset.value);
      if (!value || !this.pcard) return;
      var titleEl = this.pcard.querySelector('.m-product-card__name');
      if (titleEl) {
        if (!titleEl.dataset.baseTitle) {
          titleEl.dataset.baseTitle = titleEl.textContent.trim();
        }
        titleEl.textContent = titleEl.dataset.baseTitle + ' - ' + cleanColorLabel(value);
      }
    };
  });

  /* ── 3: Product page H1 update ── */
  document.addEventListener('DOMContentLoaded', function () {
    /* Apply swatch images immediately on page load */
    applySwatchImages();

    /* Inject badges immediately and re-apply when content lazy-loads */
    injectProductBadges();

    /* Re-apply swatch images and badges when new content is lazy-loaded */
    var observer = new MutationObserver(function (mutations) {
      var hasNew = mutations.some(function (m) { return m.addedNodes.length > 0; });
      if (hasNew) {
        applySwatchImages();
        injectProductBadges();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    /* ── H1 title on product page ── */
    var h1 = document.querySelector('h1.m-product-title');
    if (!h1) return;

    h1.dataset.baseTitle = h1.textContent.trim();

    function applyColorToTitle() {
      var sel = document.querySelector('.option-label--selected');
      if (!sel) return;
      var color = cleanColorLabel(sel.textContent.trim());
      if (color) h1.textContent = h1.dataset.baseTitle + ' - ' + color;
    }

    applyColorToTitle();

    var titleObserver = new MutationObserver(applyColorToTitle);
    document.querySelectorAll('.option-label--selected').forEach(function (el) {
      titleObserver.observe(el, { childList: true, subtree: true, characterData: true });
    });

    document.addEventListener('change', function (e) {
      if (e.target.type === 'radio') {
        var node = e.target.closest('[data-option-type="color"]');
        if (!node) return;
        h1.textContent = h1.dataset.baseTitle + ' - ' + cleanColorLabel(e.target.value);
      }
    });

    /* ── Hide empty custom-liquid blocks ──
       Shopify's CSS minifier strips :has() so we inject the style via JS instead */
    (function () {
      var s = document.createElement('style');
      s.textContent =
        '.main-product__block-custom_liquid:has(.m-product-text:not(:has(*)))' +
        '{display:none!important;height:0!important;margin:0!important;padding:0!important;overflow:hidden!important}' +
        '.slothy-badge--hot{background:linear-gradient(135deg,#ff4d00,#ff8c00)!important;color:#fff!important;font-weight:700!important;}';
      document.head.appendChild(s);
    })();


    /* ── Delivery availability badge ──
       Shows stock + shipping info between title and price on specific products.
       To extend to all products, remove the handle check. */
    (function () {
      /* applies to all active product pages */
      if (!document.querySelector('.product-block-group--price')) return;

      var priceBlock = document.querySelector('.product-block-group--price');
      if (!priceBlock) return;

      /* Inject CSS */
      var style = document.createElement('style');
      style.textContent = [
        '.slothy-avail{padding:8px 0 14px;margin-bottom:2px;direction:rtl;font-family:inherit;}',
        '.slothy-avail__stock{display:inline-flex;align-items:center;gap:7px;font-size:13px;font-weight:600;color:#16a34a;margin-bottom:6px;line-height:1;}',
        '.slothy-avail__icon{width:18px;height:18px;flex-shrink:0;}',
        '.slothy-avail__ship{display:flex;align-items:center;gap:0;font-size:12.5px;color:#6b7280;flex-wrap:wrap;line-height:1.6;}',
        '.slothy-avail__row{display:flex;align-items:center;gap:6px;}',
        '.slothy-avail__dot{width:3px;height:3px;border-radius:50%;background:#d1d5db;margin:0 6px;flex-shrink:0;}',
        '@media(max-width:480px){.slothy-avail__dot{display:none;} .slothy-avail__ship{flex-direction:column;align-items:flex-start;gap:2px;}}',
      ].join('');
      document.head.appendChild(style);

      /* Build badge HTML */
      var badge = document.createElement('div');
      badge.className = 'slothy-avail';
      badge.innerHTML =
        '<div class="slothy-avail__stock">' +
          '<svg class="slothy-avail__icon" viewBox="0 0 18 18" fill="none" aria-hidden="true">' +
            '<circle cx="9" cy="9" r="9" fill="#dcfce7"/>' +
            '<path d="M5 9.5l3 3 5-6" stroke="#16a34a" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
          '<span>זמין במלאי</span>' +
        '</div>' +
        '<div class="slothy-avail__ship">' +
          '<div class="slothy-avail__row">' +
            '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true" style="flex-shrink:0">' +
              '<path d="M1 9.5h8.5V2H1v7.5z" stroke="#9ca3af" stroke-width="1.1" stroke-linejoin="round"/>' +
              '<path d="M9.5 4.5H11l1.5 2v3H9.5V4.5z" stroke="#9ca3af" stroke-width="1.1" stroke-linejoin="round"/>' +
              '<circle cx="3.5" cy="11" r="1" stroke="#9ca3af" stroke-width="1.1"/>' +
              '<circle cx="10.5" cy="11" r="1" stroke="#9ca3af" stroke-width="1.1"/>' +
            '</svg>' +
            '<span>ת״א והסביבה: משלוח תוך 3 שעות</span>' +
          '</div>' +
          '<div class="slothy-avail__dot"></div>' +
          '<div class="slothy-avail__row">' +
            '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true" style="flex-shrink:0">' +
              '<rect x="1" y="1" width="11" height="11" rx="2" stroke="#9ca3af" stroke-width="1.1"/>' +
              '<path d="M4 6.5l2 2 3-3.5" stroke="#9ca3af" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
            '<span>לרוב למחרת · שאר הארץ, לא כולל אזורים חריגים</span>' +
          '</div>' +
        '</div>';

      priceBlock.parentNode.insertBefore(badge, priceBlock);
    })();

    /* JS fallback: also check by content for older browsers */
    document.querySelectorAll('.main-product__block-custom_liquid').forEach(function (block) {
      var inner = block.querySelector('.m-product-text');
      if (!inner) return;
      var clone = inner.cloneNode(true);
      clone.querySelectorAll('script, style, noscript').forEach(function (el) { el.remove(); });
      if (clone.textContent.trim() === '' && clone.querySelectorAll('img, video, iframe').length === 0) {
        /* Only hide if no meaningful child elements remain */
        var kids = Array.prototype.slice.call(clone.children).filter(function (el) {
          return el.offsetHeight > 0 || el.offsetWidth > 0 || el.textContent.trim() !== '';
        });
        if (kids.length === 0) block.style.display = 'none';
      }
    });
  });
})();






/* ── Shipping options block ──
   Renders shipping rows below the add-to-cart form.
   TEST: iPhone 16 only. Remove handle check to roll out to all. */
(function () {
function getHandle() {
    var el = document.querySelector('product-info[data-product-handle]');
    if (el) return el.getAttribute('data-product-handle');
    var el2 = document.querySelector('[data-product-handle]');
    if (el2) return el2.getAttribute('data-product-handle');
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function inject() {
    if (document.getElementById('slothy-ship')) return;
    var handle = getHandle();
var form = document.querySelector('product-form.m-product-form--main');
    if (!form) return;

    var style = document.createElement('style');
    style.textContent = [
      '#slothy-ship{direction:rtl;font-family:inherit;padding:0 0 4px;}',
      '#slothy-ship__label{font-size:11px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:#9ca3af;padding:14px 0 8px;}',
      '.slothy-ship__row{display:flex;align-items:center;gap:10px;padding:10px 0;border-top:1px solid #f0f0f0;}',
      '.slothy-ship__icon{font-size:16px;flex-shrink:0;width:22px;text-align:center;}',
      '.slothy-ship__body{flex:1;}',
      '.slothy-ship__name{font-size:13px;font-weight:500;color:#111;}',
      '.slothy-ship__sub{font-size:12px;color:#6b7280;margin-top:1px;}',
      '.slothy-ship__price{font-size:13px;font-weight:600;color:#111;flex-shrink:0;}',
      '.slothy-ship__price--free{color:#16a34a;}',
      '.slothy-ship__note{font-size:11.5px;color:#9ca3af;line-height:1.45;padding:8px 0 2px;}',
    ].join('');
    document.head.appendChild(style);

    var rows = [
      {
        icon: '🏪',
        name: 'איסוף עצמי מהחנות',
        sub: 'נחלת בנימין 65, תל אביב',
        price: 'חינם', free: true
      },
      {
        icon: '📦',
        name: 'מהיום למחר לנקודת איסוף UPS',
        sub: 'למזמינים עד השעה 14:00',
        price: '₪15', free: false
      },
      {
        icon: '🚚',
        name: 'מהיום למחר עד הבית — שאר הארץ',
        sub: 'למזמינים עד השעה 14:00 (לא כולל אזורים חריגים)',
        price: '₪35', free: false
      },
      {
        icon: '🏠',
        name: 'שליח עד הבית — ת״א והסביבה',
        sub: 'משלוח תוך 3 שעות',
        price: '₪59', free: false
      },
    ];

    var wrap = document.createElement('div');
    wrap.id = 'slothy-ship';
    wrap.innerHTML = '<div id="slothy-ship__label">משלוח ואיסוף</div>' +
      rows.map(function(r) {
        return '<div class="slothy-ship__row">' +
          '<span class="slothy-ship__icon">' + r.icon + '</span>' +
          '<div class="slothy-ship__body">' +
            '<div class="slothy-ship__name">' + r.name + '</div>' +
            '<div class="slothy-ship__sub">' + r.sub + '</div>' +
          '</div>' +
          '<span class="slothy-ship__price' + (r.free ? ' slothy-ship__price--free' : '') + '">' + r.price + '</span>' +
        '</div>';
      }).join('') +
      '<div class="slothy-ship__note">„מהיום למחר” ברוב המקרים, לא כולל אזורים חריגים. הזמן משוער ואינו התחייבות.</div>';

    form.parentNode.insertBefore(wrap, form.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  setTimeout(inject, 800);
  setTimeout(inject, 2000);
})();

(function () {
  if (document.getElementById('slothy-return-style')) return;
  var s = document.createElement('style');
  s.id = 'slothy-return-style';
  s.textContent = '.slothy-return-highlight{outline:2px solid rgba(0,0,0,.18);outline-offset:4px;transition:outline-color .8s ease;}';
  document.head.appendChild(s);
})();

/* === slothy collection scroll restore === */
(function () {
  'use strict';
  var KEY = 'slothy_collection_return';
  var MAX_AGE_MS = 45 * 60 * 1000;

  function isCollectionPage() {
    return /\/collections\//.test(location.pathname) &&
      !!document.querySelector('[data-product-container]');
  }
  function collectionKey() { return location.pathname + location.search; }
  function productHandleFromHref(href) {
    try {
      var u = new URL(href, location.origin);
      var m = u.pathname.match(/\/products\/([^\/\?\#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }
  function findProductCard(handle) {
    if (!handle) return null;
    var sel = 'a[href*="/products/' + handle + '"]';
    var links = document.querySelectorAll(sel);
    for (var i = 0; i < links.length; i++) {
      var card = links[i].closest('.m-product-item') || links[i];
      if (card) return card;
    }
    return null;
  }
  function getCollection() {
    return (window.MinimogTheme && MinimogTheme.Collection) ? MinimogTheme.Collection : null;
  }
  function saveState(handle) {
    if (!isCollectionPage()) return;
    var col = getCollection();
    var state = {
      key: collectionKey(),
      handle: handle || null,
      scrollY: window.scrollY || window.pageYOffset || 0,
      pages: (col && col.currentPage) ? col.currentPage : 1,
      ts: Date.now()
    };
    try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }
  function readState() {
    try {
      var raw = sessionStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function clearState() { try { sessionStorage.removeItem(KEY); } catch (e) {} }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function waitForPageBump(col, fromPage, timeoutMs) {
    return new Promise(function (resolve) {
      var start = Date.now();
      (function tick() {
        if (col.currentPage > fromPage) return resolve(true);
        if (Date.now() - start > timeoutMs) return resolve(false);
        setTimeout(tick, 80);
      })();
    });
  }
  async function loadUntil(targetPages, handle) {
    var col = getCollection();
    if (!col || typeof col.loadMoreProducts !== 'function') return;
    if (col.infiniteLoadingObserver) {
      try { col.infiniteLoadingObserver.disconnect(); } catch (e) {}
    }
    var guard = 0;
    while (guard++ < 40) {
      if (handle && findProductCard(handle)) break;
      if (col.currentPage >= targetPages) break;
      if (col.currentPage >= col.totalPages) break;
      var before = col.currentPage;
      try { col.loadMoreProducts(); } catch (e) { break; }
      var ok = await waitForPageBump(col, before, 10000);
      if (!ok) break;
      await wait(60);
    }
    if (col.paginationType === 'infinite' && col.domNodes && col.domNodes.loadMoreBtn && col.currentPage < col.totalPages) {
      try {
        col.infiniteLoadingObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio === 1) col.loadMoreProducts();
          });
        }, { threshold: 1 });
        col.infiniteLoadingObserver.observe(col.domNodes.loadMoreBtn);
      } catch (e) {}
    }
  }
  function scrollToSaved(state) {
    var card = state.handle ? findProductCard(state.handle) : null;
    if (card) {
      var top = card.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo(0, Math.max(0, top));
      card.classList.add('slothy-return-highlight');
      setTimeout(function () { card.classList.remove('slothy-return-highlight'); }, 1200);
      return;
    }
    if (typeof state.scrollY === 'number') window.scrollTo(0, state.scrollY);
  }
  async function restoreIfNeeded() {
    if (!isCollectionPage()) return;
    var state = readState();
    if (!state || state.key !== collectionKey()) return;
    if (!state.ts || Date.now() - state.ts > MAX_AGE_MS) { clearState(); return; }
    var tries = 0;
    while (!getCollection() && tries++ < 50) await wait(100);
    if (!getCollection()) return;
    var targetPages = Math.max(1, state.pages || 1);
    if (targetPages > 1 || (state.handle && !findProductCard(state.handle))) {
      await loadUntil(targetPages, state.handle);
      if (state.handle && !findProductCard(state.handle)) {
        var col = getCollection();
        await loadUntil(Math.min(targetPages + 3, col.totalPages || targetPages), state.handle);
      }
    }
    await new Promise(function (r) { requestAnimationFrame(function () { requestAnimationFrame(r); }); });
    scrollToSaved(state);
    setTimeout(clearState, 1500);
  }
  document.addEventListener('click', function (e) {
    if (!isCollectionPage()) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (!a) return;
    var handle = productHandleFromHref(a.getAttribute('href') || '');
    if (!handle) return;
    saveState(handle);
  }, true);
  window.addEventListener('pagehide', function () {
    if (!isCollectionPage()) return;
    var prev = readState();
    saveState(prev && prev.handle ? prev.handle : null);
  });
  function bootRestore() {
    var state = readState();
    if (!state || state.key !== collectionKey()) return;
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var isBack = nav && nav.type === 'back_forward';
    if (isBack || (document.referrer && document.referrer.indexOf('/products/') !== -1) || state.handle) {
      if ('scrollRestoration' in history) {
        try { history.scrollRestoration = 'manual'; } catch (e) {}
      }
      restoreIfNeeded();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(bootRestore, 50); });
  } else {
    setTimeout(bootRestore, 50);
  }
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) setTimeout(bootRestore, 50);
  });
  if (!document.getElementById('slothy-return-style')) {
    var s = document.createElement('style');
    s.id = 'slothy-return-style';
    s.textContent = '.slothy-return-highlight{outline:2px solid rgba(0,0,0,.18);outline-offset:4px;}';
    (document.head || document.documentElement).appendChild(s);
  }
})();

/* ------------------------------------------------------------------ */
/* Slothy: relabel the dynamic "Buy it now" button -> "לרכישה מהירה"   */
/* The shopify-payment-button renders an unbranded fallback button      */
/* whose text is Shopify-managed; we override it on the client side.    */
/* ------------------------------------------------------------------ */
(function () {
  var NEW_LABEL = 'לרכישה מהירה';
  function relabel() {
    var btns = document.querySelectorAll('.shopify-payment-button__button--unbranded');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      // Only touch the idle state (plain text, no spinner/child elements)
      if (btn.children.length === 0) {
        var txt = (btn.textContent || '').trim();
        if (txt && txt !== NEW_LABEL) btn.textContent = NEW_LABEL;
      }
    }
  }
  function boot() {
    relabel();
    try {
      var mo = new MutationObserver(function () { relabel(); });
      mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* SLOTHY_WHATSAPP_BLOCK v2 - phone (yellow marker) + WhatsApp CTA line below */
(function () {
  var WA = 'https://wa.me/972538037773?text=' + encodeURIComponent('היי 👋 אשמח לעזרה בהזמנה');
  function injectCSS() {
    if (document.getElementById('slothy-wa-css')) return;
    var s = document.createElement('style'); s.id = 'slothy-wa-css';
    s.textContent = [
      '.slothy-phone-stack{display:inline-flex;flex-direction:column;align-items:center;justify-content:center;line-height:1.05;gap:1px;margin-left:24px;}',
      '.m-topbar__phone[data-slothy-wa]{background:linear-gradient(transparent 58%,#ffe14d 58%) !important;color:inherit !important;padding:0 2px;font-weight:700;font-size:15px !important;border-radius:0;box-shadow:none;white-space:nowrap;direction:ltr;}',
      '.slothy-wa{display:inline-flex;align-items:center;gap:3px;font-size:10.5px;font-weight:600;text-decoration:none;color:#1f2a12;white-space:nowrap;direction:rtl;background:linear-gradient(transparent 55%,#ffe14d 55%);padding:0 4px;border-radius:2px;}',
      '.slothy-wa:hover{filter:brightness(1.03);}',
      '.slothy-wa svg{width:11px;height:11px;flex:0 0 auto;opacity:.9;}',
      '@media (max-width:767px){.slothy-phone-stack{margin-left:12px;}.m-topbar__phone[data-slothy-wa]{font-size:12px !important;}.slothy-wa{font-size:9px;gap:2px;padding:0 3px;}.slothy-wa svg{width:9px;height:9px;}}'
    ].join('');
    document.head.appendChild(s);
  }
  var ICON = '<svg viewBox="0 0 24 24" fill="#25D366" xmlns="http://www.w3.org/2000/svg"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.29-1.38a9.9 9.9 0 0 0 4.75 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.86 9.86 0 0 0 12.04 2zm5.8 14.13c-.24.68-1.42 1.32-1.95 1.36-.5.05-.97.24-3.26-.68-2.75-1.08-4.5-3.9-4.64-4.08-.14-.18-1.11-1.48-1.11-2.82 0-1.34.7-2 .95-2.27.24-.27.53-.34.71-.34.18 0 .36 0 .51.01.16.01.39-.06.6.46.24.55.82 1.9.89 2.04.07.14.12.3.02.48-.09.18-.14.3-.27.46-.14.16-.29.36-.41.48-.14.14-.28.29-.12.57.16.27.72 1.18 1.54 1.91 1.06.94 1.95 1.24 2.23 1.38.27.14.43.12.59-.07.16-.18.68-.79.86-1.06.18-.27.36-.23.6-.14.24.09 1.55.73 1.82.86.27.14.45.2.51.32.07.11.07.63-.17 1.31z"/></svg>';
  function build() {
    injectCSS();
    var phones = document.querySelectorAll('.m-topbar__phone');
    for (var i = 0; i < phones.length; i++) {
      var ph = phones[i];
      if (ph.getAttribute('data-slothy-wa')) continue;
      ph.setAttribute('data-slothy-wa', '1');
      var stack = document.createElement('span'); stack.className = 'slothy-phone-stack';
      ph.parentNode.insertBefore(stack, ph);
      stack.appendChild(ph);
      var wa = document.createElement('a');
      wa.className = 'slothy-wa'; wa.href = WA; wa.target = '_blank'; wa.rel = 'noopener';
      wa.setAttribute('data-no-loader','1');
      wa.innerHTML = ICON + '<span>מענה מהיר בוואצפ</span>';
      stack.appendChild(wa);
    }
  }
  function boot() {
    build();
    try { new MutationObserver(build).observe(document.body || document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();


/* SLOTHY_COLLECTION_CSS */
(function(){var s=document.createElement('style');s.id='slothy-collection-css';s.textContent=".m-product-card{background:transparent !important;border:none !important;padding:0 !important;box-shadow:none !important;transition:transform .25s ease;}.m-product-card:hover{transform:translateY(-3px);}.m-product-card__media{background:#f4f4f5;border-radius:12px;overflow:hidden;}.m-product-card__content{padding:12px 4px 4px;}.m-collection__products,.m-product-list,.m-collection-listing{gap:14px !important;}.m-sidebar--filter{position:static !important;}.collection-seo-section{max-width:820px;margin:14px auto 24px;padding:15px 22px;background:#f7f7f9;border-radius:14px;text-align:center;}.collection-seo-section .m-section,.collection-seo-section section{padding:0 !important;}.collection-seo-section p{margin:.3em 0;color:#4a4a4a;font-size:14px;line-height:1.6;}.collection-seo-section strong{color:#1a1a1a;}@media(max-width:767px){.collection-seo-section{margin:10px 12px 16px;padding:12px 16px;}.collection-seo-section p{font-size:13px;}}";(document.head||document.documentElement).appendChild(s);})();

/* ===== Slothy Cart Upsell (native, curated) ===== */
(function () {
  if (window.__slothyUpsellInit) return;
  window.__slothyUpsellInit = true;
  function addUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart/add.js';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.slothy-upsell__add') : null;
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.d;
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      })
      .catch(function (err) { console.error('[slothy-upsell]', err); })
      .finally(function () { btn.classList.remove('is-loading'); });
  });
})();

/* slothy-acc-gate – 18 PM 256 eSIM at 5599 requires accessories >= 199 ILS */
(function () {
  'use strict';
  var MIN_ACC = 19900;
  /* סיום מבצע שעון ישראל. ריק = פעיל. דוגמה: '2026-10-19T23:59:59+03:00' */
  var PROMO_END = '2026-10-12T23:59:59+03:00';
  function promoLive() {
    if (!PROMO_END) return true;
    var t = Date.parse(PROMO_END);
    return !isNaN(t) && Date.now() < t;
  }
  if (!promoLive()) return;
  var PROMO = {
    'iphone-18-pro-max-256gb-black-esim': 1,
    'iphone-18-pro-max-256gb-glacier-esim': 1,
    'iphone-18-pro-max-256gb-burgundy-esim': 1,
    'iphone-18-pro-max-256gb-silver-esim': 1
  };
  var ACC_TYPES = {
    case: 1, headphones: 1, charger: 1, speaker: 1, adapter: 1,
    'screen protector': 1, tripod: 1, 'apple adapter': 1
  };
  var ACC_URL = '/collections/accessories';
  var MSG = 'המבצע מותנה ב-199₪ אביזרים לכל מכשיר. הוסיפו אביזרים לסל כדי להמשיך לתשלום.';

  function isPromo(item) {
    return !!(item && item.handle && PROMO[item.handle]);
  }
  function isAppleHeadphones(item) {
    var vendor = String(item.vendor || '').toLowerCase();
    var t = String(item.product_type || '').toLowerCase();
    var blob = (String(item.handle || '') + ' ' + String(item.product_title || item.title || '')).toLowerCase();
    if (/airpods|airpod|איירפודס|אייר-פודס|earpods|earpod/.test(blob)) return true;
    if ((vendor === 'apple' || vendor === 'אפל') && (t === 'headphones' || /אוזנ|headphone|earphone|earbuds/.test(blob))) return true;
    return false;
  }
  function isAccessory(item) {
    if (!item || isPromo(item)) return false;
    if (isAppleHeadphones(item)) return false;
    var t = String(item.product_type || '').toLowerCase();
    if (t === 'smartphone' || t === 'tablet') return false;
    if (ACC_TYPES[t]) return true;
    var h = String(item.handle || '');
    if (/(iphone-|galaxy-|ipad-|nokia-)/.test(h) && !/(case|כיסוי|מגן|pitaka|otterbox)/.test(h)) {
      return false;
    }
    return t !== 'smartphone';
  }
  function evalCart(cart) {
    var promoQty = 0;
    var acc = 0;
    (cart.items || []).forEach(function (item) {
      var qty = Number(item.quantity || 1);
      if (isPromo(item)) promoQty += qty;
      else if (isAccessory(item)) acc += Number(item.final_line_price || item.line_price || 0);
    });
    var needMin = promoQty * MIN_ACC;
    return {
      hasPromo: promoQty > 0,
      promoQty: promoQty,
      acc: acc,
      ok: promoQty === 0 || acc >= needMin,
      need: Math.max(0, needMin - acc)
    };
  }
  function shekels(agorot) {
    return Math.ceil(agorot / 100);
  }
  function ensureStyle() {
    if (document.getElementById('slothy-acc-gate-style')) return;
    var s = document.createElement('style');
    s.id = 'slothy-acc-gate-style';
    s.textContent =
      '#slothy-acc-gate{direction:rtl;text-align:right;background:#fff6e8;border:1px solid #e8c98a;color:#1a1a1a;border-radius:12px;padding:12px 14px;margin:10px 0;line-height:1.6;font-size:14px;}' +
      '#slothy-acc-gate a{color:#1a3a5c;font-weight:700;text-decoration:underline;}' +
      '.slothy-acc-gate-lock{pointer-events:none;opacity:.45;}' +
      'body.slothy-acc-gate-on .shopify-payment-button{display:none !important;}';
    (document.head || document.documentElement).appendChild(s);
  }
  function bannerHtml(state) {
    var left = shekels(state.need);
    var required = shekels((state.promoQty || 1) * MIN_ACC);
    return MSG + ' ל-' + (state.promoQty || 1) + ' מכשירים נדרשים <strong>' + required + '₪</strong> אביזרים. חסרים עוד <strong>' + left + '₪</strong>. <a href="' + ACC_URL + '">לבחירת אביזר</a>';
  }
  function placeBanner(state) {
    var old = document.querySelectorAll('#slothy-acc-gate');
    old.forEach(function (n) { n.remove(); });
    if (!state.hasPromo || state.ok) return;
    var hosts = [
      document.querySelector('.m-cart-drawer__footer'),
      document.querySelector('cart-drawer .m-cart__footer'),
      document.querySelector('[data-cart-footer]'),
      document.querySelector('#CartDrawer'),
      document.querySelector('form[action="/cart"]'),
      document.querySelector('form[action="/cart/"]'),
      document.querySelector('.m-cart')
    ];
    var html = '<div id="slothy-acc-gate">' + bannerHtml(state) + '</div>';
    var placed = false;
    hosts.forEach(function (host) {
      if (!host || placed) return;
      host.insertAdjacentHTML('afterbegin', html);
      placed = true;
    });
    if (!placed && document.body) {
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      wrap.firstChild.style.position = 'sticky';
      wrap.firstChild.style.bottom = '12px';
      wrap.firstChild.style.zIndex = '9999';
      wrap.firstChild.style.margin = '12px';
      document.body.appendChild(wrap.firstChild);
    }
  }
  function lockCheckout(lock) {
    var sels = [
      '[name="checkout"]',
      'button[formaction*="checkout"]',
      'a[href="/checkout"]',
      'a[href*="/checkout"]',
      '.m-cart__checkout',
      '.m-cart-drawer__checkout',
      '#checkout',
      'button[name="goto_pp"]',
      '.additional-checkout-buttons',
      '.shopify-payment-button'
    ];
    sels.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (lock) {
          el.classList.add('slothy-acc-gate-lock');
          el.setAttribute('aria-disabled', 'true');
          if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') el.disabled = true;
        } else {
          el.classList.remove('slothy-acc-gate-lock');
          el.removeAttribute('aria-disabled');
          if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') el.disabled = false;
        }
      });
    });
    document.body.classList.toggle('slothy-acc-gate-on', !!lock);
  }
  var lastState = { hasPromo: false, acc: 0, ok: true, need: 0 };
  function apply(cart) {
    ensureStyle();
    lastState = evalCart(cart || { items: [] });
    var lock = lastState.hasPromo && !lastState.ok;
    placeBanner(lastState);
    lockCheckout(lock);
  }
  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {});
  }
  document.addEventListener('click', function (e) {
    if (!lastState.hasPromo || lastState.ok) return;
    var el = e.target && e.target.closest
      ? e.target.closest('[name="checkout"], a[href="/checkout"], a[href*="/checkout"], .shopify-payment-button, button[formaction*="checkout"], .m-cart__checkout, .m-cart-drawer__checkout')
      : null;
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    placeBanner(lastState);
    if (el.scrollIntoView) {
      var b = document.getElementById('slothy-acc-gate');
      if (b) b.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);
  document.addEventListener('submit', function (e) {
    if (!lastState.hasPromo || lastState.ok) return;
    var form = e.target;
    if (!form || !form.action) return;
    if (String(form.action).indexOf('/cart') === -1 && String(form.action).indexOf('checkout') === -1) return;
    var submitter = e.submitter;
    if (submitter && submitter.name && submitter.name !== 'checkout') return;
    e.preventDefault();
    e.stopPropagation();
    placeBanner(lastState);
  }, true);
  ['cart:updated', 'cart:refresh', 'cart:change', 'minimog:cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(refresh, 80); });
  });
  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      return _fetch.apply(this, args).then(function (res) {
        try {
          var u = String((args[0] && args[0].url) || args[0] || '');
          if (/\/cart(\.js|\/add|\/change|\/update|\/clear)/.test(u)) setTimeout(refresh, 120);
        } catch (err) {}
        return res;
      });
    };
  }
  var path = (location.pathname || '');
  var onPromoProduct = Object.keys(PROMO).some(function (h) { return path.indexOf('/products/' + h) !== -1; });
  if (onPromoProduct) {
    ensureStyle();
    document.body.classList.add('slothy-acc-gate-on');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  setTimeout(refresh, 800);
})();


/* ===== Slothy cart upsell rows (cases + camera by model) ===== */
(function () {
  if (window.__slothyUpsellFill) return;
  window.__slothyUpsellFill = true;

  var CAM_GENERIC = 'מגן-לעדשות-המצלמה-עשוי-זכוכית-לשמירה-על-איכות-הצילום';
  var CAM_17PM = 'כיסוי-מלא-לעדשות-מצלמה-אייפון-17-פרו-מקס-ninthpro';
  var CAM_17P = 'כיסוי-מלא-לעדשות-מצלמה-אייפון-17-פרו-ninthpro';
  var CASE_COLS = ['pitaka-cases', 'apple-cases', 'otterbox-cases'];

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      return r.ok ? r.json() : null;
    }).catch(function () { return null; });
  }

  function fmtMoney(raw, cents) {
    var n = cents ? Number(raw) / 100 : parseFloat(raw);
    if (isNaN(n)) return '';
    if (window.Shopify && Shopify.formatMoney && cents) return Shopify.formatMoney(Number(raw));
    return '₪' + Math.round(n);
  }

  function imgSrc(p) {
    if (p.featured_image) {
      var f = p.featured_image;
      return typeof f === 'string' ? f : (f.src || '');
    }
    if (p.images && p.images[0]) return p.images[0].src || p.images[0];
    return '';
  }

  function firstAvail(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
    return vs[0] || null;
  }

  function cardHTML(p, cents) {
    var v = firstAvail(p);
    if (!v) return '';
    var priceRaw = v.price;
    var cmpRaw = v.compare_at_price;
    var price = fmtMoney(priceRaw, cents);
    var onSale = cmpRaw && parseFloat(cents ? Number(cmpRaw) / 100 : cmpRaw) > parseFloat(cents ? Number(priceRaw) / 100 : priceRaw);
    var priceHtml = onSale
      ? '<span class="slothy-upsell__price--sale">' + price + '</span><s class="slothy-upsell__price--was">' + fmtMoney(cmpRaw, cents) + '</s>'
      : price;
    var url = p.url || ('/products/' + p.handle);
    var img = imgSrc(p);
    var title = (p.title || '').replace(/</g, '&lt;');
    return '<div class="slothy-upsell__card">' +
      '<a href="' + url + '" class="slothy-upsell__media" tabindex="-1"><img src="' + img + '" alt="" width="52" height="52" loading="lazy"></a>' +
      '<div class="slothy-upsell__info"><a href="' + url + '" class="slothy-upsell__name">' + title + '</a>' +
      '<div class="slothy-upsell__price">' + priceHtml + '</div></div>' +
      '<button type="button" class="slothy-upsell__add" data-variant-id="' + v.id + '" aria-label="הוספה לעגלה">' +
      '<span class="slothy-upsell__add-plus">+</span><span class="slothy-upsell__add-spin" aria-hidden="true"></span></button></div>';
  }

  function hayOf(p) {
    var tags = Array.isArray(p.tags) ? p.tags.join(',') : String(p.tags || '');
    return ((p.title || '') + ',' + (p.handle || '') + ',' + tags).toLowerCase();
  }

  function matchesModel(p, model) {
    var hay = hayOf(p);
    var uni = false;
    if (model.family === 'iphone' && /למגוון דגמי אייפון|לדגמי אייפון/.test(hay)) uni = true;
    if (model.family === 'samsung' && /למגוון דגמי סמסונג|לדגמי סמסונג/.test(hay)) uni = true;
    var hit = uni || hay.indexOf(model.en) !== -1 || (model.he && hay.indexOf(model.he) !== -1);
    if (!hit) return false;
    if (uni) return true;
    if (model.exact === 'base' && /pro|air|\bmax\b|פרו|אייר|מקס/.test(hay)) return false;
    if (model.exact === 'pro' && /pro max|פרו מקס|air|אייר/.test(hay)) return false;
    if (model.exact === 'air' && !/air|אייר/.test(hay)) return false;
    return true;
  }

  function inCart(p, pids) {
    return pids.indexOf(',' + p.id + ',') !== -1;
  }

  function loadCasePool() {
    var reqs = [];
    CASE_COLS.forEach(function (handle) {
      [1, 2, 3, 4].forEach(function (page) {
        reqs.push(getJSON('/collections/' + encodeURIComponent(handle) + '/products.json?limit=50&page=' + page));
      });
    });
    return Promise.all(reqs).then(function (pages) {
      var out = [];
      var seen = {};
      pages.forEach(function (d) {
        (d && d.products || []).forEach(function (p) {
          if (p && p.id && !seen[p.id]) { seen[p.id] = 1; out.push(p); }
        });
      });
      return out;
    });
  }

  function pickCases(pool, model, pids) {
    var matched = pool.filter(function (p) {
      if (inCart(p, pids)) return false;
      var t = (p.product_type || '').toLowerCase();
      if (t && t.indexOf('case') === -1 && t.indexOf('כיסוי') === -1) return false;
      var hay = hayOf(p);
      if (/עדשות|camera lens/.test(hay)) return false;
      if (!firstAvail(p) || !firstAvail(p).available) return false;
      return matchesModel(p, model);
    });
    matched.sort(function (a, b) {
      return parseFloat(firstAvail(b).price) - parseFloat(firstAvail(a).price);
    });
    var picked = [];
    var prices = {};
    matched.forEach(function (p) {
      if (picked.length >= 3) return;
      var pr = String(firstAvail(p).price);
      if (prices[pr] && Object.keys(prices).length < 2) return;
      prices[pr] = 1;
      picked.push(p);
    });
    matched.forEach(function (p) {
      if (picked.length >= 3) return;
      if (picked.indexOf(p) !== -1) return;
      picked.push(p);
    });
    return picked;
  }

  function fillEl(el) {
    if (el.getAttribute('data-js-filled') === '1') return;
    var en = (el.getAttribute('data-model-en') || '').trim();
    if (!en) return;
    el.setAttribute('data-js-filled', '1');
    var model = {
      en: en.toLowerCase(),
      he: (el.getAttribute('data-model-he') || '').toLowerCase(),
      exact: el.getAttribute('data-model-exact') || '',
      family: el.getAttribute('data-model-family') || ''
    };
    var pids = el.getAttribute('data-cart-pids') || ',';
    var caseRow = el.querySelector('[data-fill="cases"]');
    var camRow = el.querySelector('[data-fill="camera"]');

    var caseP = loadCasePool().then(function (pool) {
      if (!caseRow) return;
      var picked = pickCases(pool, model, pids);
      if (!picked.length) return;
      caseRow.querySelector('.slothy-upsell__track').innerHTML = picked.map(function (p) { return cardHTML(p, false); }).join('');
      caseRow.hidden = false;
      caseRow.classList.add('is-ready');
    });

    var camHandles = [CAM_GENERIC];
    if (model.en.indexOf('17 pro max') !== -1) camHandles.push(CAM_17PM);
    else if (model.en.indexOf('17 pro') !== -1) camHandles.push(CAM_17P);

    var camP = Promise.all(camHandles.map(function (h) {
      return getJSON('/products/' + encodeURIComponent(h) + '.js');
    })).then(function (list) {
      if (!camRow) return;
      var html = '';
      list.forEach(function (p) {
        if (!p || inCart(p, pids)) return;
        var v = firstAvail(p);
        if (!v || v.available === false) return;
        html += cardHTML(p, true);
      });
      if (!html) return;
      camRow.querySelector('.slothy-upsell__track').innerHTML = html;
      camRow.hidden = false;
      camRow.classList.add('is-ready');
    });

    return Promise.all([caseP, camP]).catch(function (err) {
      console.error('[slothy-upsell-fill]', err);
    });
  }

  function scan() {
    document.querySelectorAll('slothy-cart-upsell[data-model-en]').forEach(fillEl);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('cart:refresh', function () { setTimeout(scan, 200); });
  document.addEventListener('cart:updated', function () { setTimeout(scan, 200); });
  new MutationObserver(function () { scan(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
